import { Button, Form, Input, message, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';
import axios from 'axios';
import React from 'react';

function AddTopic({ isModalVisible, setIsModalVisible, selectedCategory, fetchTopics }) {
    let [form] = useForm();
    const handleCreateTopic = async (values) => {
        try {
            await axios.post('/forum/topics', {
                ...values,
                category_id: selectedCategory,
                user_id: localStorage.getItem('token')
            });
            message.success('Mavzu muvaffaqiyatli yaratildi');
            setIsModalVisible(false);
            form.resetFields();
            fetchTopics(selectedCategory);
        } catch (error) {
            console.error('Mavzu yaratishda xatolik:', error);
            message.error('Mavzu yaratishda xatolik yuz berdi');
        }
    };

    return (
        <Modal
            title="Yangi mavzu yaratish"
            open={isModalVisible}
            onCancel={() => {
                setIsModalVisible(false);
                form.resetFields();
            }}
            footer={null}
        >
            <Form
                form={form}
                onFinish={handleCreateTopic}
                layout="vertical"
            >
                <Form.Item
                    name="title"
                    label="Mavzu nomi"
                    rules={[{ required: true, message: 'Iltimos, mavzu nomini kiriting' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="description"
                    label="Mavzu mazmuni"
                    rules={[{ required: true, message: 'Iltimos, mavzu mazmunini kiriting' }]}
                >
                    <TextArea rows={4} />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Yaratish
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default AddTopic;